import React from 'react';
import { Link } from 'react-router';
import { css, StyleSheet } from 'aphrodite';
import { fromJS } from 'immutable';
import R from 'ramda';

const styles = StyleSheet.create({
  notesHeader: { display: 'flex', width: '100%' },
  noteBox: {
    border: '1px dashed rgba(0, 0, 0, 0.54)',
    display: 'flex',
    alignItems: 'flex-start',
    margin: '8px auto',
    padding: '6px',
  },
  text: { whiteSpace: 'pre-wrap', width: '20%' },
  tfbox: { width: '80%' },
  tf: { width: '100%' },
});

const PreviewNotes = ({
  updateThisProductWithKeyPath,
  notes = [],
}) => {
  const updateNote = i => e => {
    updateThisProductWithKeyPath(['notes'], fromJS(R.update(i, {
      ...notes[i],
      text: e.target.value,
    }, notes)));
  };
  return (
    <div>
      <div className={css(styles.notesHeader)}>
        <div style={{ width: '20%' }}/>
        <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' }}>Notes</div>
      </div>
      <div style={{ width: '80%', marginLeft: '20%' }}>
        {
          (() => {
            if (R.isEmpty(notes)) {
              return (<div style={{ color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' }}>
                No available notes, please <Link to="/integration/settings/notes">set up your notes settings here</Link>.
              </div>);
            }
            return notes.map((note, index) => {
              return (
                <div
                  key={index}
                  className={css(styles.noteBox)}
                >
                  <div className={css(styles.text)}>
                    <b>{note.code}</b>
                  </div>
                  <div className={css(styles.tfbox)}>
                    <textarea
                      rows={4}
                      value={note.text}
                      onChange={updateNote(index)}
                    />
                  </div>
                </div>
              );
            });
          })()
        }
      </div>
    </div>);
}

export default PreviewNotes;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-notes.jsx